/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpErrorResponse, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuppressionDto as PlatformSuppressionDto } from '../../models/platform/suppression-dto';

export interface GetSuppressionInformation$Params {
  token: string;
}

export function getSuppressionInformation(http: HttpClient, rootUrl: string, params: GetSuppressionInformation$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSuppressionDto | undefined>> {
  const rb = new RequestBuilder(rootUrl, getSuppressionInformation.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<PlatformSuppressionDto | undefined>;
    }),
    catchError((e: unknown) => {
      if (e instanceof HttpErrorResponse && e.status === HttpStatusCode.NotFound) {
        const response = new HttpResponse({ status: e.status, statusText: e.statusText, headers: e.headers, url: e.url ?? undefined });
        // HttpResponse turns an undefined body into null
        return of(Object.assign(response, { body: undefined }) as StrictHttpResponse<PlatformSuppressionDto | undefined>);
      }
      return throwError(() => e);
    })
  );
}

getSuppressionInformation.PATH = '/mailing-list-resubscribe-page';

function revivePlatformSuppressionDto(value: any): any {
  if (value) {
    if (value["suppressedAt"] != null) {
      value["suppressedAt"] = parseDateTime(value["suppressedAt"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = revivePlatformSuppressionDto(body);
  }
  return body;
}
